// DISCIPLAY — Wishlist (localStorage only, no backend)
// Storage: `ds4_wishlist_v1` → array of product handles
// Public API on window.DSWishlist: { list(), has(h), toggle(h), add(h), remove(h), count() }
// DOM hooks:
//   [data-wishlist-btn][data-product-handle]    toggle button (cards, PDP)
//   [data-wishlist-count]                       header badge (auto-shown/hidden)
//   [data-wishlist-grid]                        wishlist page container
//   [data-wishlist-empty]                       wishlist page empty state
// Fires `wishlist-change` on window when state mutates.

(function () {
  'use strict';
  const KEY = 'ds4_wishlist_v1';
  const EVT = 'wishlist-change';
  const PRODUCT_FETCH_BASE = '/products/';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(EVT, { detail: { list } }));
  }

  const api = {
    list:  () => read(),
    count: () => read().length,
    has:   (h) => read().indexOf(h) !== -1,
    add(h) {
      if (!h) return;
      const list = read();
      if (list.indexOf(h) === -1) { list.unshift(h); write(list); }
    },
    remove(h) {
      const list = read().filter((x) => x !== h);
      write(list);
    },
    toggle(h) {
      if (!h) return;
      api.has(h) ? api.remove(h) : api.add(h);
    },
  };
  window.DSWishlist = api;

  // ── Header badge sync ──
  function syncBadge() {
    const n = api.count();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(n);
      el.toggleAttribute('hidden', n === 0);
    });
  }
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const h = btn.dataset.productHandle;
      const on = api.has(h);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const lbl = btn.dataset[on ? 'labelOn' : 'labelOff'];
      if (lbl) btn.setAttribute('aria-label', lbl);
    });
  }
  function syncAll() { syncBadge(); syncButtons(); }

  // ── Click delegation ──
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    api.toggle(btn.dataset.productHandle);
  });

  window.addEventListener(EVT, syncAll);
  // Cross-tab sync
  window.addEventListener('storage', (e) => { if (e.key === KEY) syncAll(); });

  document.addEventListener('DOMContentLoaded', () => {
    syncAll();
    hydrateWishlistPage();
  });

  // ── Wishlist page hydration ──
  // The wishlist-grid section renders an empty container; we fetch each saved
  // product as JSON and inject a card. No SSR — the list is per-device.
  async function hydrateWishlistPage() {
    const grid  = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    const handles = api.list();
    if (handles.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = '';

    const cards = await Promise.all(handles.map(fetchAndRenderCard));
    cards.filter(Boolean).forEach((card) => grid.appendChild(card));
  }

  async function fetchAndRenderCard(handle) {
    try {
      const res = await fetch(PRODUCT_FETCH_BASE + handle + '.js');
      if (!res.ok) {
        // Product was deleted / unpublished — drop from wishlist
        if (res.status === 404) api.remove(handle);
        return null;
      }
      const p = await res.json();
      return buildCard(p);
    } catch {
      return null;
    }
  }

  function money(cents) {
    // Shopify .js endpoint returns prices in cents
    const v = (cents / 100).toFixed(2);
    return '$' + v;
  }

  function buildCard(p) {
    const card = document.createElement('article');
    card.className = 'wish-card';
    card.dataset.productId = p.id;
    const img = p.featured_image
      ? `<img src="${p.featured_image}" alt="${escapeAttr(p.title)}" width="600" height="600" loading="lazy" class="wish-card__img">`
      : '';
    const sale = p.compare_at_price && p.compare_at_price > p.price
      ? `<span class="wish-card__price-compare">${money(p.compare_at_price)}</span>`
      : '';
    card.innerHTML = `
      <a href="${p.url}" class="wish-card__link" aria-label="${escapeAttr(p.title)}">
        <div class="wish-card__media">${img}</div>
        <div class="wish-card__body">
          ${p.type ? `<div class="wish-card__category">${escapeText(p.type).toUpperCase()}</div>` : ''}
          <h3 class="wish-card__title">${escapeText(p.title)}</h3>
          <div class="wish-card__price">${money(p.price)} ${sale}</div>
        </div>
      </a>
      <button type="button" class="wish-card__remove" data-wishlist-btn data-product-handle="${escapeAttr(p.handle)}"
              aria-label="Remove from wishlist" aria-pressed="true">✕</button>
    `;
    return card;
  }

  function escapeText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeAttr(s) {
    return escapeText(s).replace(/"/g, '&quot;');
  }
})();
